<template>
  <div class="template-confing-container">
    <Condition ref="condition" :onSearch="onSearch" :loading="loading" />

    <div class="template-table-container">
      <TableHeadIcons
        style="position: relative"
        :onRefresh="onSearch"
        :size.sync="tableDensity"
        :columns="columns"
      >
        <a-button type="primary" @click="onCreate">新建</a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="id"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="templateType" slot-scope="text, record, index">
          {{ text === 1 ? '网页内容抽取' : '翻页模版' }}
        </span>
        <span slot="enabled" slot-scope="text, record, index">
          {{ text === 1 ? '停用' : '启用' }}
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="onUpdate(record)"> 编辑 </a>
          <a-divider type="vertical" />
          <a @click="toggleEnable(record)"> {{ record.enabled === 0 ? '停用' : '启用' }} </a>
        </span>
      </a-table>
    </div>

    <a-drawer
      :title="formMod == 'create' ? '新增模版' : '修改模版'"
      width="600"
      :closable="true"
      :visible="isShowModal"
      @close="isShowModal = false"
    >
      <a-form-model
        :model="formData"
        ref="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item label="模版类型" prop="templateType">
          <a-radio-group name="radioGroup" v-model="formData.templateType">
            <a-radio :value="1"> 网页内容抽取 </a-radio>
            <a-radio :value="0"> 翻页模版 </a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="模版名称" prop="templateName">
          <a-input v-model="formData.templateName"></a-input>
        </a-form-model-item>

        <template v-if="formData.templateType === 1">
          <div class="form-text">
            <span>字段解析</span>
          </div>

          <a-form-model-item label="title" prop="title">
            <a-input v-model="formData.title"></a-input>
          </a-form-model-item>
          <a-form-model-item label="content" prop="content">
            <a-input v-model="formData.content"></a-input>
          </a-form-model-item>
          <a-form-model-item label="publisher" prop="publisher">
            <a-input v-model="formData.publisher"></a-input>
          </a-form-model-item>
          <a-form-model-item label="publish_time" prop="publisher_time">
            <a-input v-model="formData.publisherTime"></a-input>
          </a-form-model-item>
          <a-form-model-item label="keywords" prop="keywords">
            <a-input v-model="formData.keyword"></a-input>
          </a-form-model-item>
          <a-form-model-item label="file" prop="file">
            <a-input v-model="formData.file"></a-input>
          </a-form-model-item>
          <a-form-model-item label="origin" prop="origin">
            <a-input v-model="formData.origin"></a-input>
          </a-form-model-item>
          <a-form-model-item label="description" prop="description">
            <a-input v-model="formData.description"></a-input>
          </a-form-model-item>
        </template>

        <template v-else>
          <a-form-model-item label="模版参数" prop="param">
            <a-input v-model="formData.param"></a-input>
          </a-form-model-item>
        </template>

        <a-form-model-item label="是否启用" prop="enabled">
          <a-switch
            :default-checked="formData.enabled === 0"
            @change="formData.enabled = formData.enabled === 1 ? 0 : 1"
          ></a-switch>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            {{ formMod == 'create' ? '创 建' : '修 改' }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-drawer>
  </div>
</template>

<script>
import Condition from './Condition'
import {
  queryTemlateListApi,
  createTemplateApi,
  updateTemplateApi,
  toggleTemplateEnabledApi
} from '@/api/Site/Template'
import { onHttpResponseSilent } from '@/utils/request'

export default {
  components: { Condition },

  data() {
    return {
      tableDensity: 'middle',
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'left',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '模版名称',
          dataIndex: 'templateName',
          show: true,
          align: 'left'
        },
        {
          title: '模版类型',
          dataIndex: 'templateType',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'templateType' }
        },
        {
          title: '模版状态',
          dataIndex: 'enabled',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'enabled' }
        },
        {
          title: '创建人员',
          dataIndex: 'createName',
          show: true,
          align: 'left'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          show: true,
          align: 'left'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          align: 'left'
        }
      ],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },

      tableData: [],
      condition: {},

      formData: {},
      formMod: 'create',
      isShowModal: false,
      rules: {
        templateName: [{ required: true, message: '模版名称必填', trigger: ['change', 'blur'] }]
      }
    }
  },

  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },

  created() {
    this.getTableData()
  },

  methods: {
    onSearch(condition) {
      if (condition) {
        this.condition = condition
      }
      this.pagination.current = 1
      this.getTableData()
    },

    async getTableData() {
      this.loading = true
      const query = {
        ...this.condition,
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      queryTemlateListApi(query)
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.tableData = data
          this.pagination.total = extra.page.pageCount || 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getTableData()
    },

    onCreate() {
      this.formData = {
        templateType: 1,
        templateName: '',
        enabled: 0,
        title: '',
        content: '',
        publisher: '',
        publisherTime: '',
        keyword: '',
        file: '',
        origin: '',
        description: '',
        param: ''
      }
      this.formMod = 'create'
      this.isShowModal = true
    },

    onUpdate(record) {
      this.formData = { ...record }
      this.formMod = 'update'
      this.isShowModal = true
    },

    toggleEnable(record) {
      toggleTemplateEnabledApi(record.id)
        .then(onHttpResponseSilent)
        .then(() => {
          this.$message.success('操作成功')
          this.getTableData()
        })
    },

    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return
        }

        const apiFunc = this.formMod === 'create' ? createTemplateApi : updateTemplateApi

        apiFunc(this.formData)
          .then(onHttpResponseSilent)
          .then(() => {
            if (this.formData === 'create') {
              this.onSearch()
            } else {
              this.getTableData()
            }
            this.isShowModal = false
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.template-confing-container {
  width: 100%;
  padding: 16px;
}

.template-table-container {
  background: white;
  margin-top: 16px;
  padding: 0 16px;
}

.form-text {
  text-align: center;
  margin-bottom: 12px;
  padding-left: 48px;

  span {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: -12px;
      top: 3px;
      bottom: 1px;
      width: 4px;
      background-color: #1890ff;
    }
  }
}
</style>
